import { useState } from "react";
import { InputField, MainButton, Loader } from "commonUI";
import "./auth.css";
import { useNavigate } from "react-router-dom";
import { Logo } from "allIcons";
import { printError, useSearch, useUtilities } from "helpers";
import { ApiResponseType } from "enums";
import axios from "axios";
import { t } from "i18next";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [userInput, setUserInput] = useState({
    password: "",
    confirm_password: "",
    error: "",
    sucess: "",
  });
  const { rt, email } = useSearch();
  const [loading, setLoading] = useState(false);
  const { notification } = useUtilities();

  function handleResetPassword(e) {
    e.preventDefault();
    if (userInput.password.length < 8) {
      setUserInput({
        ...userInput,
        error: t("resetPassword.input.error.minimumLenghthRequired"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    if (userInput.password.length > 30) {
      setUserInput({
        ...userInput,
        error: t("resetPassword.input.error.maximumLenghthExceeded"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    if (userInput.password !== userInput.confirm_password) {
      setUserInput({
        ...userInput,
        error: t("resetPassword.input.error.passwordsDoNotMatch"),
        sucess: "",
      });
      return;
    }
    if (
      !userInput.password.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#-_^])[A-Za-z\d@$!%*?&#-_^]{8,40}$/
      )
    ) {
      setUserInput({
        ...userInput,
        error: t("resetPassword.input.error.passwordsMustMatchPattern"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}resetpassword`, {
        email,
        password: userInput.password,
        rt,
      })
      .then((res) => res.data)
      .then((data) => {
        if (data.status_code === ApiResponseType.SUCCESS) {
          setUserInput({
            ...userInput,
            sucess: data.message,
            error: "",
          });
          notification({
            message: t("resetPassword.api.success.passwordUpdated"),
            type: "success",
          });
          navigate("/login");
        } else {
          setUserInput({
            ...userInput,
            error: printError(data.message),
            sucess: "",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setUserInput({
          ...userInput,
          error: t("resetPassword.api.error.invalidEmail"),
          sucess: "",
        });
        setLoading(false);
      });
  }
  return (
    <>
      <Loader show={loading} />
      <div className={`login-container`}>
        <div className="">
          <div
            className={`flex items-center bg-transparent mb-[87px] justify-center`}
          >
            <Logo className="logo-size" />
          </div>
          <div className="login-form">
            <h2 className="login-heading">{t("resetPassword.title")}</h2>
            <div className="py-4 w-fit mx-auto max-w-25rem">
              {userInput.error ? (
                <p className="error-text mb-1">{userInput.error}</p>
              ) : (
                userInput.sucess && (
                  <p className="success-text mb-1">{userInput.sucess}</p>
                )
              )}
              <InputField
                type="text"
                name="email"
                id="email_address"
                placeholder={t("resetPassword.input.email.placeholder")}
                value={email}
                inputClass="py-1"
                disabled
              />
              <InputField
                type="password"
                name="password"
                id="password"
                placeholder={t("resetPassword.input.password.placeholder")}
                value={userInput.password}
                inputClass="py-1"
                setValue={(value) =>
                  setUserInput({ ...userInput, password: value })
                }
              />
              <InputField
                type="password"
                name="confirm_password"
                id="confirm_password"
                placeholder={t("resetPassword.input.confirmPassword.placeholder")}
                value={userInput.confirm_password}
                inputClass="py-1"
                setValue={(value) =>
                  setUserInput({
                    ...userInput,
                    confirm_password: value,
                  })
                }
              />
              <div className="py-2">
                <MainButton
                  onClick={handleResetPassword}
                  className={`w-full py-2 `}
                >
                  {t("resetPassword.button.updatePassword")}
                </MainButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
